import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";

import { tx, useLang } from "../lib/i18n";
export const Logo = ({ tagline = "Shop in motion.", compact = false }) => { useLang();
  const { setSearchOpen, setCartOpen } = useApp();
  return (
    <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3 shrink-0" onClick={() => { setSearchOpen(false); setCartOpen(false); }} aria-label={tx("MIVO home")}>
      <img src="/assets/brand/mivo-mark.png" alt="" className="h-8 w-auto lg:h-9" />
      <span className="flex flex-col leading-none">
        <img src="/assets/brand/mivo-wordmark.png" alt="MIVO" className="h-[15px] w-auto lg:h-[17px] self-start" />
        {tx(!compact && <span className="mt-1.5 text-[11px] lg:text-xs text-[var(--mv-muted)] font-medium" data-testid="header-tagline">{tx(tagline)}</span>)}
      </span>
    </Link>
  );
};
